import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import configureStore from "./configureStore";
import Main from "Main";
import { isLab, isLocalhost, isProduction } from "common-ui-components/components/utils/Config";

const store = configureStore();

window.store = store;

if (process.env.NODE_ENV === "development") 
{
  const resizeObserverErrors = new Set([
    "ResizeObserver loop completed with undelivered notifications.",
    "ResizeObserver loop limit exceeded",
  ]);

  window.addEventListener("error", (event) => {
    if (resizeObserverErrors.has(event?.message)) {
      event.stopImmediatePropagation();
    }
  });
}

if(isProduction())
{
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
  console.info = () => {};
  console.debug = () => {};
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <Main />
  </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();